import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from "react-router-dom";

import * as AppUrls from "../../../constants/AppUrls";


import "react-toastify/dist/ReactToastify.css";

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";


import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import i18next from 'i18next';
import { toast } from "react-toastify";
import "./OnboardingMain.modules.css";

import NavbarOnboarding from '../NavbarOnboarding/NavbarOnboarding'
import AccountCreationOnboarding from './AccountCreationOnboarding/AccountCreationOnboarding'
import ReviewOnboardingSteps from './ReviewOnboardingSteps/ReviewOnboardingSteps'


toast.configure();

function OnboardingMain() {
    const { t } = useTranslation();

    const [redirect, setRedirect] = useState(null);
    if (redirect !== null) {
        return <Redirect to={redirect} />;
    }

    return (
        <div style={{width: '100%' , height: '100%'}}>
            <NavbarOnboarding />
            <div className="OnboardingMain-container">
                <ReviewOnboardingSteps />
                <div className="OnboardingMain-form">

                    <AccountCreationOnboarding />

                </div>


            </div>
        </div>
    );
}

export default OnboardingMain;

